<template>
    <div class="fixed inset-0 z-top pointer-events-none">
        <transition
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
            name="fade-in"
        >
            <div
                v-if="show"
                class="transition-opacity ease-in-out duration-300 pointer-events-auto absolute inset-0"
                @click="$emit('close')"
            >
                <div class="w-full h-full bg-primary opacity-50"></div>
            </div>
        </transition>
        <transition
            enter-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-class="translate-x-0"
            leave-to-class="translate-x-full"
            name="slide-from-right"
        >
            <div v-if="show"
                 :class="fullWidth ? 'left-72': ''"
                 class="transform transition-transform ease-in-out duration-300 pointer-events-auto absolute min-w-320 inset-y-0 right-0 bg-primary-5 shadow-md h-screen flex flex-col"
            >
                <div :class="useHeader ? 'border-b-2 border-primary-20 bg-white' : '' "
                     class="h-72 flex-none flex items-center pl-24 ">
                    <div v-if="icon" class="mr-12">
                        <svg-icon
                            :type="icon"
                            class="max-w-16 max-h-16 text-primary-80"
                        ></svg-icon>
                    </div>
                    <span
                        class="first-letter:uppercase text-body leading-none mr-auto mt-px"
                    >{{ title }}
                    </span>
                    <button class="group mr-24" @click="$emit('close')">
                        <svg-icon class="max-w-24 max-h-24 text-primary-40 group-hover:text-semantic-error trans-ease" type="cancel"></svg-icon>
                    </button>
                </div>
                <div class="flex-grow overflow-y-scroll overflow-x-hidden pt-24 pl-24">
                    <div class="mr-20 mb-24">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        icon: String,
        title: {
            type: String,
            required: true,
        },
        useHeader: {
            type: Boolean,
            default: true,
        },
        fullWidth: Boolean,
    },
};
</script>
